module.exports = __webpack_public_path__ + "img/orange2.3958548f.png";